// States (or statuses) on which report is available
import { InboxItemType, VerificationRequestStatus } from 'src/api';

export const reportAvailableVerificationRequestStatuses: VerificationRequestStatus[] = [
  VerificationRequestStatus.ReportCreated,
  VerificationRequestStatus.ReviewedByVerifier,
];

export const InboxItemTypeWithResources = {
  ...InboxItemType,
  Resources: 'Resources',
} as const;
export type InboxItemTypeWithResources =
  (typeof InboxItemTypeWithResources)[keyof typeof InboxItemTypeWithResources];

export const InboxItemTitleMap = {
  [InboxItemTypeWithResources.ApiVerificationRequest]: 'API Verification Request',
  [InboxItemTypeWithResources.VerificationRequest]: 'Verification Request',
  [InboxItemTypeWithResources.TestVerificationRequest]: 'Test Verification Request',
  [InboxItemTypeWithResources.DataDispute]: 'Data Dispute',
  [InboxItemTypeWithResources.Resources]: 'Resources',
} as const satisfies { [key in InboxItemTypeWithResources]: string };
export type InboxItemTitleMap = (typeof InboxItemTitleMap)[keyof typeof InboxItemTitleMap];

export enum InboxPageLayout {
  Inbox = 'Inbox',
  TestRequests = 'Test Requests',
}
